// eslint-disable import/prefer-default-export
import { format, intervalToDuration, lightFormat, parseISO } from 'date-fns'
import { fr } from 'date-fns/locale'
import i18n from '@/plugins/i18n'

export function formatDate(date?: string, fallback = '-') : string {
  return date ? format(parseISO(date), i18n.locale === 'en' ? 'MM/dd/yyyy' : 'dd/MM/yyyy') : fallback
}

export function formatDateTime(date?: string) : string {
  return date ? lightFormat(parseISO(`${date}Z`), i18n.locale === 'en' ? 'MM/dd/yyyy \'at\' HH:mm' : 'dd/MM/yyyy \'à\' HH:mm') : '-'
}

export function formatBetween(date1String: string, date2String: string) : string {
  const date1 = parseISO(`${date1String}Z`)
  const date2 = parseISO(`${date2String}Z`)
  const duration = intervalToDuration({ start: date1, end: date2 })

  if (duration.days && duration.days > 0) {
    let result = i18n.locale === 'en' ? 'From ' : 'Du '

    if ((duration.years ?? 0) > 0) {
      result += format(date1, i18n.locale === 'en' ? 'dd MMMM yyyy' : 'dd MMMM yyyy', { locale: i18n.locale === 'en' ? undefined : fr })
    } else if ((duration.months ?? 0) > 0) {
      result += format(date1, i18n.locale === 'en' ? 'dd MMMM' : 'dd MMMM', { locale: i18n.locale === 'en' ? undefined : fr })
    } else {
      result += date1.getUTCDate()
    }

    result += i18n.locale === 'en' ? ' to ' : ' au '
    return result + format(date2, i18n.locale === 'en' ? 'dd MMMM yyyy' : 'dd MMMM yyyy', { locale: i18n.locale === 'en' ? undefined : fr })
  } else {
    return (i18n.locale === 'en' ? 'On ' : 'Le ') + format(date2, i18n.locale === 'en' ? 'dd MMMM yyyy' : 'dd MMMM yyyy', { locale: i18n.locale === 'en' ? undefined : fr })
  }
}

export function formatCountdown(date: string) : string {
  const duration = intervalToDuration({ start: parseISO(new Date().toISOString()), end: parseISO(date) })
  const months = 12 * (duration.years ?? 0) + (duration.months ?? 0)
  switch (i18n.locale) {
    case 'fr':
      return `${months ? `${months}m, ` : ''}${duration.days ?? 0}j, ${duration.hours ?? 0}h et ${duration.minutes ?? 0}min`
    case 'en':
      return `${months ? `${months}m, ` : ''}${duration.days ?? 0}d, ${duration.hours ?? 0}h and ${duration.minutes ?? 0}min`
    default:
      return ''
  }
}

export type LocalDateTime = string

export type LocalDate = string
